import { apiClientGeral, apiDownloadAudio } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'

export default {
  async getrelatorios(body = null) {
    return apiClientGeral().post(`/cdr?page=${body.currentPage}`, body)
  },

  gerarRelatorio(form, page) {
    return apiClientGeral().post(`/relatorios/pabx?_method=GET&page=${page}`, form)
  },

  async getplayAudio(path) {
    let response = await apiDownloadAudio().get(`/gravacao/download/${path}`)
    return response
  },

  getCentroDeCustos() {
    return apiClientGeral().get('/centrodecusto')
  },

  getConferencias() {
    return apiClientGeral().get('/conferencias')
  },

  getTags() {
    return apiClientGeral().get('/tags')
  },

  exportPdf(params) {
    let query = `dataHoraInicio=${encodeURI(params.dataHoraInicio)}&dataHoraFim=${encodeURI(params.dataHoraFim)}`

    params.numeroOrigem.forEach(origem => {
      query = `${query}&numeroOrigem[]=${origem}`
    })

    params.numeroDestino.forEach(destino => {
      query = `${query}&numeroDestino[]=${destino}`
    })

    params.centroDeCusto.forEach(centroDeCusto => {
      query = `${query}&centroDeCusto[]=${centroDeCusto}`
    })

    params.status.forEach(status => {
      query = `${query}&status[]=${status}`
    })

    params.protocol.forEach(protocol => {
      query = `${query}&protocol[]=${protocol}`
    })

    return `https://${hostname()}/backend/asterisk/relatorios/cdr/export?${query}`
  },
}
